<div class="container-menu">
  <div class="mobile-menu" [ngClass]="['mobile', brand === 'VIVUS' ? 'vivus-style' : '']">
    <button
      pButton
      pRipple
      icon="pi pi-sign-out"
      class="p-button-text"
      (click)="logout()"
    >
      <span class="logout">Выйти</span>
    </button>
  </div>
</div>
